export default "__VITE_ASSET__CmMU50LQ__"